if(!customElements.get('card-310')) {
    customElements.define('card-310', class Card310 extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.init();
        }

        init() {
            this.select = this.querySelector('select');

            this.hiddenIdInputs = this.querySelectorAll('input[type="hidden"][name="id"]');
            this.hiddenSellingPlanInput = this.querySelector('input[type="hidden"][name="selling_plan"]');

            // two-buttons mode
            this.subscriptionButton = this.querySelector('.card-310__product-form--subscribe');

            // subscribe-first mode
            this.onetimeButton = this.querySelector('.card-310__product-form--onetime');

            // checkbox mode
            this.checkboxSubscribe = this.querySelector('.card-310__checkbox-input');
            this.sellingPlanInput = this.querySelector('.card-310__selling-plan-input');

            // checkbox mode: dual price containers
            this.priceOnetime = this.querySelector('.card-310__price--onetime');
            this.priceSubscribe = this.querySelector('.card-310__price--subscribe');

            this.priceContainer = this.querySelector('.card-310__price-container');
            this.pricePerServingContainer = this.querySelector('.card-310__price-serving');
            this.bestBeforeDateContainer = this.querySelector('.card-310__best-before-badge');

            this.badgeText = this.querySelector('.badge-text');
            this.badgeDiscount = this.querySelector('.badge-discount');
            this.badgeDiscountText = this.querySelector('.badge-discount .card-310__img-badge-text');

            this.handleVariantChange = this.handleVariantChange.bind(this);

            this.select?.addEventListener('change', (e) => {
                this.handleVariantChange(e);
            });

            // usage-tier quantity pills (Size × Quantity products)
            this.tierPills = [...this.querySelectorAll('.card-310__tier-pill')];
            this.tierPills.forEach(pill => {
                pill.addEventListener('click', () => this.selectTierPill(pill));
            });
            if (this.tierPills.length) {
                const initOption = this.select
                    ? this.select.options[this.select.selectedIndex]
                    : null;
                this.showTierGroup(initOption?.dataset.sizeGroup || this.tierPills[0].dataset.tierGroup);
            }

            // checkbox mode: toggle selling_plan input and price on checkbox change
            if (this.checkboxSubscribe && this.sellingPlanInput) {
                this.syncSellingPlanToCheckbox();
                this.checkboxSubscribe.addEventListener('change', () => {
                    this.syncSellingPlanToCheckbox();
                    this.togglePriceDisplay();
                });
            }
        }

        syncSellingPlanToCheckbox() {
            this.sellingPlanInput.disabled = !this.checkboxSubscribe.checked;
        }

        togglePriceDisplay() {
            if (!this.priceOnetime || !this.priceSubscribe) return;
            const showSubscribe = this.checkboxSubscribe
                ? this.checkboxSubscribe.checked
                : true;
            if (showSubscribe) {
                this.priceOnetime.style.display = 'none';
                this.priceSubscribe.style.display = '';
            } else {
                this.priceOnetime.style.display = '';
                this.priceSubscribe.style.display = 'none';
            }
        }

        showTierGroup(group) {
            if (!this.tierPills?.length) return;
            this.tierPills.forEach(p => { p.hidden = p.dataset.tierGroup !== group; });
            const first = this.tierPills.find(p => !p.hidden);
            if (first) this.selectTierPill(first);
        }

        selectTierPill(pill) {
            this.tierPills.forEach(p => p.classList.toggle('is-active', p === pill));
            this.applyOptionData(pill.dataset, pill.dataset.variant);
        }

        handleVariantChange(e) {
            const selectedOption = [...e.target.options].find(option => option.selected);

            // tiered product: the size change switches the visible pill group,
            // and the auto-selected first pill (1 Bag) applies the variant data
            if (this.tierPills?.length && selectedOption.dataset.sizeGroup) {
                this.showTierGroup(selectedOption.dataset.sizeGroup);
                return;
            }

            this.applyOptionData(selectedOption.dataset, e.target.value);
        }

        applyOptionData(data, variantId) {
            // update hidden inputs
            this.hiddenIdInputs?.forEach(input => {
                input.value = variantId;
            });

            // usage-tier products carry a different selling plan per variant —
            // keep every selling_plan input in sync with the selected variant
            if (data.sellingPlanId) {
                this.querySelectorAll('input[type="hidden"][name="selling_plan"]').forEach(input => {
                    input.value = data.sellingPlanId;
                });
            }

            // update price container
            if (this.priceOnetime && this.priceSubscribe) {
                // checkbox mode: update both inner containers
                this.priceOnetime.innerHTML = data.price;
                if (data.subPrice) {
                    this.priceSubscribe.innerHTML = data.subPrice;
                }
                this.togglePriceDisplay();
            } else {
                // two-buttons mode: update whole container
                this.priceContainer.innerHTML = data.price;
            }

            // update discount container
            if( this.badgeDiscount && this.badgeDiscountText ){
                const discount = data.discount?.trim();
                const hasDiscount = !!discount;

                this.badgeDiscount.style.display = hasDiscount ? 'block' : 'none';
                this.badgeDiscountText.innerHTML = hasDiscount ? discount : '';

                if (this.badgeText) {
                    this.badgeText.style.display = hasDiscount ? 'none' : 'block';
                }
            }

            // Update best before label
            if(data.bestBeforeDate){
                if(!this.bestBeforeDateContainer.classList.contains('show')){
                    this.bestBeforeDateContainer.classList.add('show');
                }
                this.bestBeforeDateContainer.innerHTML = data.bestBeforeDate;
            }else{
                this.bestBeforeDateContainer.classList.remove('show');
            }

            // two-buttons mode: update subscription button
            if(this.subscriptionButton) {
                if( data.subDiscountedPrice ){
                    this.subscriptionButton.querySelector('.sub-discounted-price').innerHTML = data.subDiscountedPrice;
                    this.subscriptionButton.style.display = 'block';
                }else{
                    this.subscriptionButton.style.display = 'none';
                }
            }

            // subscribe-first mode: update one-time button price
            if(this.onetimeButton) {
                const onetimePriceEl = this.onetimeButton.querySelector('.onetime-price');
                if (onetimePriceEl && data.pricePlain) {
                    onetimePriceEl.innerHTML = data.pricePlain;
                }
            }

            // checkbox mode: update sub-price + selling_plan value
            if (this.checkboxSubscribe) {
                const checkboxSection = this.checkboxSubscribe.closest('.card-310__checkbox-subscribe');

                if (data.subDiscountedPrice) {
                    if (checkboxSection) checkboxSection.style.removeProperty('display');

                    if (this.sellingPlanInput && data.sellingPlanId) {
                        this.sellingPlanInput.value = data.sellingPlanId;
                        this.syncSellingPlanToCheckbox();
                    }
                } else {
                    // variant has no subscription — hide checkbox, show regular price
                    if (checkboxSection) checkboxSection.style.display = 'none';
                    if (this.sellingPlanInput) this.sellingPlanInput.disabled = true;
                    if (this.priceOnetime) this.priceOnetime.style.display = '';
                    if (this.priceSubscribe) this.priceSubscribe.style.display = 'none';
                }
            }

            // update price per serving container
            this.pricePerServingContainer.innerHTML = data.pricePerServing || '';
        }
    });
}